import { create } from "zustand";

const useProductData = create((set) => ({
    product: {},
    setProductData: (data) => set((state) => ({ product: { ...state.product, ...data } })),
}));

export default useProductData;
